import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import _str from "shared/util/_str";

const ProductPriceInfo = ({
	isSelected,
	tokenCount,
	price,
	setSelected,
	discountPercentage,
}) => {
	const discountText = _str("Save");
	const matchesText = tokenCount > 1 ? _str("Matches") : _str("Match");

	return (
		<div className="read-receipt-rate-card-product-price-info-container">
			{discountPercentage && isSelected &&
				(
					<div className="read-receipt-rate-card-product-price-info-discount">
						{`${discountText} ${discountPercentage}`}
					</div>
				)}
			<button
				className={classnames("read-receipt-rate-card-product-price-info", {
					"read-receipt-rate-card-product-price-info-selected": isSelected,
				})}
				onClick={setSelected}
			>
				<div className="read-receipt-rate-card-product-price-info-token-count">
					{tokenCount}
				</div>
				<span className="read-receipt-rate-card-product-price-info-matches">
					{matchesText}
				</span>
				{price}/ea
			</button>
		</div>
	);
};

ProductPriceInfo.propTypes = {
	isSelected: PropTypes.bool.isRequired,
	tokenCount: PropTypes.number.isRequired,
	price: PropTypes.string.isRequired,
	setSelected: PropTypes.func.isRequired,
	discountPercentage: PropTypes.string,
};

ProductPriceInfo.defaultProps = {
	discountPercentage: null,
};

export default ProductPriceInfo;



// WEBPACK FOOTER //
// ./src/shared/components/ReadReceiptRateCard/ProductPriceInfo.jsx